"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiAlert = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var colors_1 = require("../../generated/colors");
var global_1 = require("../../global");
var forms_1 = require("../../generated/icons/forms");
var ICON_SIZE = "24px";
exports.MuiAlert = {
    defaultProps: {
        iconMapping: {
            error: (0, jsx_runtime_1.jsx)(forms_1.ExclamationMarkRed, {}, void 0),
            info: (0, jsx_runtime_1.jsx)(forms_1.Info, {}, void 0),
            success: (0, jsx_runtime_1.jsx)(forms_1.Checkmark, {}, void 0),
            warning: (0, jsx_runtime_1.jsx)(forms_1.ExclamationMarkGold, {}, void 0),
        },
    },
    styleOverrides: {
        root: __assign(__assign({ width: "100%", display: "flex", color: colors_1.colors.Grey1, borderRadius: global_1.borderRadius.general, padding: global_1.spacing[3] }, global_1.typography.regular14), { "& .MuiAlert-icon": {
                padding: 0,
                marginRight: 0,
            }, "& .MuiAlert-icon svg": {
                marginRight: "12px",
                width: ICON_SIZE,
                height: ICON_SIZE,
            }, "& .MuiAlert-message": {
                alignSelf: "center",
                padding: 0,
            }, "& .MuiButtonBase-root": {
                padding: 0,
            }, "& .MuiAlert-action": {
                marginRight: 0,
            } }),
    },
};
//# sourceMappingURL=alert.js.map